<app-view-details title="معلومات الصنف" [fields]="fields()" />
